// WhatsApp configuration
const WHATSAPP_NUMBER = "96181176961"; // Replace with actual business number

export const generateWhatsAppLink = (message) => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

export const generateProductOrderMessage = (productName, price) => {
 const numericPrice = Number(price);

  return `Hello! I'm interested in ordering:\n\n*${productName}*\nPrice: $${numericPrice.toFixed(
    2
  )}\n\nPlease let me know about availability and delivery options.`;
};

export const generateGeneralInquiryMessage = () => {
  return `Hello! I'm interested in learning more about your herbal products. Could you please help me?`;
};
